import { defineNuxtPlugin } from 'nuxt/app'

/**
 * Registers the installability-only service worker (/cp-pwa-sw.js), independent of the
 * FCM push-notification plugin (firebase-messaging.client.ts) — installability must not
 * depend on Firebase config or push-permission flows succeeding. Fire-and-forget: unlike
 * sw-cleanup.client.ts, this must not block app boot.
 */
export default defineNuxtPlugin(async () => {
  if (!('serviceWorker' in navigator)) return

  try {
    await navigator.serviceWorker.register('/cp-pwa-sw.js', { scope: '/' })
  } catch {
    // Installability is best-effort — never break app boot over a failed SW registration.
  }
})
